import { render } from "./Mixed.vue?vue&type=template&id=280a13eb"
import script from "./Mixed.vue?vue&type=script&lang=js"
export * from "./Mixed.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__